// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-e5ba9e3a] #sv-nav-complete{margin-left:auto}`, "",{"version":3,"sources":["webpack://./ClientApp/components/survey/SurveyJSComponent.vue"],"names":[],"mappings":"AACA,mCACE,gBAAA","sourcesContent":["\r\n:deep(#sv-nav-complete) {\r\n  margin-left: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
